export default __webpack_public_path__ + "static/media/searching.d85716ee.svg";